import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

export const Feature = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.04, 1]);

  return (
    <section ref={ref} data-testid="feature-section" className="px-5 sm:px-10 lg:px-16 py-20 sm:py-28 ">
      <Reveal className="max-w-3xl mx-auto">
        <div data-testid="feature-image-card" className="relative rounded-[2rem] overflow-hidden border border-white/10 group">
          <motion.img style={{ scale }} src="/img/feature.jpg" alt="Carl Sagan quote from The Demon-Haunted World" className="w-full aspect-[1280/867] object-cover" />
          <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_30%_20%,transparent_40%,rgba(7,9,10,0.55))]" />
        </div>
      </Reveal>
    </section>
  );
};
